import React from 'react';
import Pro01 from "../../images/services/et/Emerging-Technologies-banner.webp"
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Agile(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container classNanme="h-100">
                <Row classNanme="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                        <div className="example" data-text="Our Work">
                            <h2>Leveraging Emerging Technologies In IT To Combine Talent With Technology</h2>
                        </div>
                        <p>TekRevol heavily relies on bringing innovation through technology to deliver an unmatched
                            experience and excellence. Our grip on emerging technology allows us to boast and provide
                            ideas impactful enough to improve lives around the globe and maintain the threshold of value
                            that we always count on.</p><p> With a focus on experience, innovation, and digital
                        solutions,
                        TekRevol aims to transform how businesses function and the lives attached to them. We use
                        emerging technologies in IT to unearth hidden ideas and brainstorm techniques that
                        custom-fit your scenario to produce a one-of-a-kind, efficient outcome.
                    </p>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="agile_title my-auto offset-xl-1">
                        <div className="content_pointer">
                            <div className="pointers_item">
                                <div className="title_count">36+<span>Projects Completed</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">23+<span>Businesses Served</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">08+<span>Industries Covered</span></div>
                            </div>
                        </div>
                        <LazyLoadImage
                            src={Pro01}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Agile;